import { render } from "./CoverLetterPreferences.vue?vue&type=template&id=f2ee569a"
import script from "./CoverLetterPreferences.vue?vue&type=script&lang=js"
export * from "./CoverLetterPreferences.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__